import { useMemo } from 'react';
import type { CountryOption } from '../models.js';
import { useCountryOptions } from '../queries/use-country-options.js';
import { useCurrentUser } from '../queries/use-current-user.js';
import { filterCountriesForUser } from './access.js';

export function useSelectableCountryOptions(): CountryOption[] {
  const countryOptions = useCountryOptions();
  const { data: user } = useCurrentUser();

  return useMemo(
    () => (user ? filterCountriesForUser(countryOptions, user) : []),
    [countryOptions, user],
  );
}
